<div class="asset-request-container" [class.hide-horizontal-scroll]="hideHorizontalScroll">
  <!-- Expand Cell Template -->
  <ng-template #expandCell let-row>
    <button
      class="expand-btn"
      type="button"
      (click)="toggleRowExpansion(row)"
      [attr.aria-expanded]="isRowExpanded(row)"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        [style.transform]="isRowExpanded(row) ? 'rotate(90deg)' : 'rotate(0deg)'"
        [style.transition]="'transform 0.2s ease'"
      >
        <path
          d="M9 18L15 12L9 6"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </ng-template>

  <!-- Child Row Template -->
  <ng-template #childRow let-row>
    <tr class="table--child-row">
      <td [attr.colspan]="columns.length" class="table--child-cell">
        <div class="child-row-content">
          <div class="child-row-grid">
            <div class="child-row-item" *ngFor="let detail of getUserDetailEntriesForRow(row)">
              <span class="child-row-label">{{ detail.label }}</span>
              <span class="child-row-value">{{ detail.value }}</span>
            </div>
            <div class="child-row-item child-row-item--purpose">
              <span class="child-row-label">Purpose</span>
              <span class="child-row-value">{{ row.purpose || 'N/A' }}</span>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </ng-template>

  <!-- Table -->
  <app-table
    [columns]="columns"
    [data]="assetRequestsData"
    [scrollHeight]="'400px'"
    [loading]="loading"
    [pagination]="pagination"
    [emptyMessage]="emptyMessage"
    [childRowTemplate]="childRow"
    [isRowExpanded]="getIsRowExpanded()"
    [striped]="true"
    [bordered]="true"
    [hoverable]="true"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (sortChange)="onSortChange($event)"
  >
    <!-- Purpose column: ellipsis, click to show full in modal -->
    <ng-template #purposeCell let-row>
      <span
        class="purpose-cell-text"
        [title]="row.purpose || ''"
        (click)="openPurposeModal(row.purpose)"
      >{{ row.purpose || '—' }}</span>
    </ng-template>

    <!-- Request Status chip -->
    <ng-template #statusCell let-row>
      <span [ngClass]="getStatusChipClass(row.requestStatus)">{{ row.requestStatus }}</span>
    </ng-template>

    <!-- Custom Action Column -->
    <ng-template #actionCell let-row>
      <div class="action-cell-wrapper">
        <button 
          class="action-btn" 
          appActionDropdownTrigger
          (click)="toggleActionDropdown($event, row)"
          [class.active]="isDropdownOpen(row)"
          type="button"
        >
          <span>Action</span>
        </button>
        
        <!-- Dropdown Menu -->
        <div 
          class="action-dropdown-menu" 
          *ngIf="isDropdownOpen(row)" 
          [attr.data-dropdown-id]="(row.originalData?.id || row.id || '')"
          (click)="$event.stopPropagation()"
        >
          <ul class="dropdown-list">
            <li class="dropdown-item">
              <button
                class="dropdown-link"
                [disabled]="isApproveRejectDisabled(row)"
                (click)="handleAction('accept', row)"
              >
                Accept
              </button>
            </li>
            <li class="dropdown-item">
              <button
                class="dropdown-link dropdown-link--danger"
                [disabled]="isApproveRejectDisabled(row)"
                (click)="handleAction('reject', row)"
              >
                Reject
              </button>
            </li>
          </ul>
        </div>
      </div>
    </ng-template>
  </app-table>

  <!-- Purpose full content modal -->
  <app-modal
    [(visible)]="showPurposeModal"
    header="Purpose"
    [width]="'480px'"
    [showFooter]="true"
    [showConfirmButton]="false"
    [showCancelButton]="true"
    cancelLabel="Close"
    (onCancel)="showPurposeModal = false"
  >
    <div class="purpose-modal-content">{{ purposeModalText }}</div>
  </app-modal>
  
  <!-- Approve asset request modal -->
  <app-modal
    [(visible)]="isApproveModalVisible"
    header="Approve Asset Request"
    [width]="'520px'"
    [modal]="true"
    [closable]="true"
    confirmLabel="Approve"
    cancelLabel="Cancel"
    [confirmButtonDisabled]="!expirationDate?.startDate || !isExpiryValid()"
    (onConfirm)="onApproveConfirm()"
    (onCancel)="closeApproveModal()"
    (onClose)="closeApproveModal()"
  >
    <div class="approve-asset-modal approve-asset-modal-content">
      <div class="approve-asset-modal__info">
        <span class="approve-asset-modal__icon" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
        </span>
        <p class="approve-asset-modal__description">
          Specify until when this access request should remain valid. The requester will have access to the asset until the selected date and time.
        </p>
      </div>
      <div class="approve-asset-modal__field">
        <label class="approve-asset-modal__label">
          Expiry At <span class="approve-asset-modal__required">*</span>
        </label>
        <div class="approve-asset-modal__date-time-row">
          <app-date-range-picker
            [(ngModel)]="expirationDate"
            [singleDateMode]="true"
            [minDate]="minDate"
            [disableFutureDates]="false"
            placeholder="Select date"
            styleClass="approve-asset-modal-date-picker"
          ></app-date-range-picker>
        </div>
        <span class="approve-asset-modal__hint">Access will be valid until this date and time</span>
      </div>
    </div>
  </app-modal>
</div>



